import { render, staticRenderFns } from "./PAF03_Core.vue?vue&type=template&id=c7ae885e&scoped=true&"
import script from "./PAF03_Core.vue?vue&type=script&lang=js&"
export * from "./PAF03_Core.vue?vue&type=script&lang=js&"
import style0 from "./PAF03_Core.vue?vue&type=style&index=0&id=c7ae885e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ae885e",
  null
  
)

export default component.exports